import { render, staticRenderFns } from "./SurveysEdit.vue?vue&type=template&id=fd988c18&"
import script from "./SurveysEdit.vue?vue&type=script&lang=js&"
export * from "./SurveysEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports